<div class="resultGroup" *ngIf="_Model && _RequestModel">
    <div class="groupHeader pointer d-flex" (click)="onToggle()">
        <div class="mr-5">
            <i class="mr-1 fas " [ngClass]="ShowGroup ? 'fa-caret-up': 'fa-caret-down'"></i>
            {{_Model.GroupName}} - <B>{{_Model.RecordCount}}</B>&nbsp;<span translate>LBL.RECORDS</span>
        </div>
        <div class="mr-5" *ngIf="Rows_Add > 0 || Rows_Update > 0">
            <span class="text-success">{{'LBL.NEW_JOBS' | translate}}: <B>{{Rows_Add}}</B></span>
            <!--&nbsp;/&nbsp;
            <span class="text-primary">{{'LBL.UPDATED_JOBS' | translate}}: <B>{{Rows_Update}}</B></span>-->
        </div>
    </div>
    <JobSearchResult [HideTotalPages]="true" [hidden]="ShowGroup == false" #jobSearchResult (onResultRefresh)="onResultRefresh()" [RequestModel]="_RequestModel"></JobSearchResult>
</div>
